import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Radio, Select } from "antd";
import { SalamHealthCoverageAPI } from "../../../Data/Data";
import { useDispatch, useSelector } from "react-redux";
import { getHealthPlan } from "../../../Redux/actions/getHealthPlan";
import { getHomePlan } from "../../../Redux/actions/getHomePlan";
import { getPAPlan } from "../../../Redux/actions/getPAPlan";

const PAFormTwo = ({
  onFinishStep2,
  onFinishFailedTwo,
  setSelectedPlan,
  selectedPlan,
  productId,
  handlePrev,
  form,
}) => {
  const dispatch = useDispatch();
  const planData = useSelector((state) => state.getPAPlan.data);
  const handleClick = (id) => {
    setSelectedPlan(id);
  };
  console.log(planData, "<=======planData");
  const handleFinish = () => {
    if (selectedPlan) {
      onFinishStep2(selectedPlan);
    }
  };
  console.log(planData.length, "<=========planData");
  useEffect(() => {
    dispatch(getPAPlan(productId));
  }, []);
  return (
    <div
      className="col-sm-8 mForm"
      style={{ backgroundColor: "rgb(30 123 95 / 69%)" }}
    >
      <div className="centreWidthFOrm">
        <h3 className="cnhbsh3">Salaam Personal Accident Takaful </h3>
        <h5 className="cnhbsh5">Coverage</h5>
        <Form
          name="sehatFormSix"
          onFinish={handleFinish}
          onFinishFailed={onFinishFailedTwo}
          autoComplete="off"
          form={form}
        >
          <div className="row sehatCrdTakaful">
            {planData &&
              planData?.map((value, index) => (
                <div className="col-sm-4 sehatTakafulCoverageCard">
                  <div className="xyz">
                    <div className="title">
                      <p>Plan {value?.Coverage}</p>
                    </div>
                    <div className="detailsSehatTakaful">
                      <div className="sehatTakDetHead">
                        <p className="heading">Contribution</p>
                        <p className="amount">
                          PKR <span>{value?.Contribution}</span>
                        </p>
                      </div>

                      <div className="sehatTakDetHead">
                        <p className="heading">AccidentMedicalExpenses</p>
                        <p className="amount">
                          {/* {value?.BuildingAndStructure ? 'PKR ' : null} */}
                          <span>
                            {value?.AccidentMedicalExpenses
                              ? value?.AccidentMedicalExpenses
                              : "--"}
                          </span>
                        </p>
                      </div>

                      <div className="sehatTakDetHead">
                        <p className="heading">
                          Accidental Death and Disability
                        </p>
                        {/* {value?.LossOfRent ? 'PKR ' : null} */}
                        <p className="amount">
                          <span>
                            {value?.AccidentalDeathANdDisability
                              ? value?.AccidentalDeathANdDisability
                              : "--"}
                          </span>
                        </p>
                      </div>
                      <div className="sehatTakDetHead">
                        <p className="heading">Burial And Repartiation</p>

                        <p className="amount">
                          <span>
                            {value?.BurialAndRepartiation
                              ? value?.BurialAndRepartiation
                              : "--"}
                          </span>
                        </p>
                      </div>

                      <div className="sehatTakDetHead">
                        <p className="heading">Total Sum Covered</p>

                        <p className="amount">
                          <span>{value?.TotalSumCovered}</span>
                        </p>
                      </div>
                    </div>

                    <Form.Item>
                      <Button
                        type="primary"
                        onClick={() => handleClick(value)}
                        htmlType="submit"
                        style={{ background: "#1C75BC" }}
                      >
                        Select
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              ))}
            <div className="col-sm-12">
              <Button onClick={handlePrev}> Back</Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default PAFormTwo;
